import { useState } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import '../../style/scss/Recruit.scss';
import { Form, FormActions, FormInput, FormCheckbox } from '../Controls/Form';
import BreadCrumb from "../Controls/BreadCrumb";
import API from "@src/API.js";
import { toast } from "react-toastify";

export default function AddEmployerVIP() {
   const navigate = useNavigate();
   const params = useParams();
   const location = useLocation();
   const employerIdFromRoute = parseInt(params.id || "0", 10);
   const employerID = location.state?.EmployerID || employerIdFromRoute;
   const [breadcrumb] = useState([...(location.state?.breadcrumb || []), 'Add VIP']);
   const [newVIP, updateVIP] = useState({
      EmployerID: employerID,
      email: "",
      recruiter: false,
      admin: false
   });

   async function onDoneAsync() {
      const resp = await API.postAsync('/Employer/Admin', {
         EmployerID: newVIP.EmployerID,
         Email: newVIP.email
      });
      if (resp && resp.ok) {
         navigate(-1);
      } else if (resp && resp.status === 404) {
         toast.error("User not found");
      } else {
         toast.error("Could not add VIP. Please try again.");
      }
   }
   return (
      <div className="pagebody">
         <BreadCrumb props={breadcrumb} />
         <div className="tabbody">
            <h2>Give a VIP special access to</h2>
            <div className="tabsection">
               <Form object={newVIP} onUpdate={updateVIP}>
                  <FormInput field="email" label="Add Employment Role via Email Address" />
                  <FormCheckbox field="recruiter" />
                  <FormCheckbox field="admin" />
                  <FormActions onSaveAsync={async () => { await onDoneAsync(); }} doneLabel="Save" onCancelReturn />
               </Form>
            </div>
         </div>
      </div>
   );
}
